/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MstCustomerCenterUpdateBase
 */
export interface MstCustomerCenterUpdateBase {
    /**
     * 
     * @type {boolean}
     * @memberof MstCustomerCenterUpdateBase
     */
    deleteFlg?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof MstCustomerCenterUpdateBase
     */
    insertDatetime?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstCustomerCenterUpdateBase
     */
    insertUser?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MstCustomerCenterUpdateBase
     */
    updateDatetime?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstCustomerCenterUpdateBase
     */
    updateUser?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MstCustomerCenterUpdateBase
     */
    deleteDatetime?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstCustomerCenterUpdateBase
     */
    deleteUser?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MstCustomerCenterUpdateBase
     */
    companyId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MstCustomerCenterUpdateBase
     */
    orgCustomerId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstCustomerCenterUpdateBase
     */
    orgCustomerCenterId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstCustomerCenterUpdateBase
     */
    customerCenterName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstCustomerCenterUpdateBase
     */
    customerCenterAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstCustomerCenterUpdateBase
     */
    customerCenterGln?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MstCustomerCenterUpdateBase
     */
    customerCenterId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MstCustomerCenterUpdateBase
     */
    transportOrgCenterId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstCustomerCenterUpdateBase
     */
    remarks?: string | null;
}

/**
 * Check if a given object implements the MstCustomerCenterUpdateBase interface.
 */
export function instanceOfMstCustomerCenterUpdateBase(value: object): value is MstCustomerCenterUpdateBase {
    return true;
}

export function MstCustomerCenterUpdateBaseFromJSON(json: any): MstCustomerCenterUpdateBase {
    return MstCustomerCenterUpdateBaseFromJSONTyped(json, false);
}

export function MstCustomerCenterUpdateBaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MstCustomerCenterUpdateBase {
    if (json == null) {
        return json;
    }
    return {
        
        'deleteFlg': json['delete_flg'] == null ? undefined : json['delete_flg'],
        'insertDatetime': json['insert_datetime'] == null ? undefined : (new Date(json['insert_datetime'])),
        'insertUser': json['insert_user'] == null ? undefined : json['insert_user'],
        'updateDatetime': json['update_datetime'] == null ? undefined : (new Date(json['update_datetime'])),
        'updateUser': json['update_user'] == null ? undefined : json['update_user'],
        'deleteDatetime': json['delete_datetime'] == null ? undefined : (new Date(json['delete_datetime'])),
        'deleteUser': json['delete_user'] == null ? undefined : json['delete_user'],
        'companyId': json['company_id'] == null ? undefined : json['company_id'],
        'orgCustomerId': json['org_customer_id'] == null ? undefined : json['org_customer_id'],
        'orgCustomerCenterId': json['org_customer_center_id'] == null ? undefined : json['org_customer_center_id'],
        'customerCenterName': json['customer_center_name'] == null ? undefined : json['customer_center_name'],
        'customerCenterAddress': json['customer_center_address'] == null ? undefined : json['customer_center_address'],
        'customerCenterGln': json['customer_center_gln'] == null ? undefined : json['customer_center_gln'],
        'customerCenterId': json['customer_center_id'] == null ? undefined : json['customer_center_id'],
        'transportOrgCenterId': json['transport_org_center_id'] == null ? undefined : json['transport_org_center_id'],
        'remarks': json['remarks'] == null ? undefined : json['remarks'],
    };
}

export function MstCustomerCenterUpdateBaseToJSON(json: any): MstCustomerCenterUpdateBase {
    return MstCustomerCenterUpdateBaseToJSONTyped(json, false);
}

export function MstCustomerCenterUpdateBaseToJSONTyped(value?: MstCustomerCenterUpdateBase | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'delete_flg': value['deleteFlg'],
        'insert_datetime': value['insertDatetime'] == null ? value['insertDatetime'] : value['insertDatetime'].toISOString(),
        'insert_user': value['insertUser'],
        'update_datetime': value['updateDatetime'] == null ? value['updateDatetime'] : value['updateDatetime'].toISOString(),
        'update_user': value['updateUser'],
        'delete_datetime': value['deleteDatetime'] == null ? value['deleteDatetime'] : value['deleteDatetime'].toISOString(),
        'delete_user': value['deleteUser'],
        'company_id': value['companyId'],
        'org_customer_id': value['orgCustomerId'],
        'org_customer_center_id': value['orgCustomerCenterId'],
        'customer_center_name': value['customerCenterName'],
        'customer_center_address': value['customerCenterAddress'],
        'customer_center_gln': value['customerCenterGln'],
        'customer_center_id': value['customerCenterId'],
        'transport_org_center_id': value['transportOrgCenterId'],
        'remarks': value['remarks'],
    };
}

